var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
import { observable, computed, action } from "mobx";
import { internalMessageBus, InternalMessageBusChannels } from "sb-internal-msg-bus";
import { defaultItemForSportMode, itemIDs } from "../../modes";
var State = /** @class */ (function () {
    function State(messageSender, blockId, itemType) {
        if (itemType === void 0) { itemType = defaultItemForSportMode.firstSport; }
        this.messageSender = messageSender;
        this.selectedItemId = observable.box("");
        this.isEventView = false;
        this.items = observable([]);
        this.blockId = blockId;
        this.internalMessageBus = internalMessageBus;
        this.defaultItemType = itemType;
        this.isActive = false;
    }
    State.prototype.activate = function () {
        this.isActive = true;
        this.subscribeToToggleEventView(this.blockId, InternalMessageBusChannels.legacy.eventCard.changedToSide);
    };
    State.prototype.deactivate = function () {
        this.isActive = false;
        this.unsubscribeToToggleEventView(this.blockId, InternalMessageBusChannels.legacy.eventCard.changedToSide);
        this.isEventView = false;
    };
    Object.defineProperty(State.prototype, "SelectedItemId", {
        get: function () {
            return this.selectedItemId.get();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(State.prototype, "Items", {
        get: function () {
            return this.items;
        },
        enumerable: true,
        configurable: true
    });
    State.prototype.add = function (item) {
        this.addToList(item, this.Items);
    };
    State.prototype.addToList = function (item, items) {
        var indexToInsert = items.findIndex(function (x) { return x.order > item.order; });
        if (indexToInsert === -1) {
            items.push(item);
        }
        else {
            items.splice(indexToInsert, 0, item);
        }
    };
    State.prototype.remove = function (id, canUpdateSelectedItem) {
        if (canUpdateSelectedItem === void 0) { canUpdateSelectedItem = false; }
        var selectedItemId = this.selectedItemId.get();
        if (!canUpdateSelectedItem && id === selectedItemId) {
            return;
        }
        var itemToRemove = this.getItemById(id);
        if (itemToRemove) {
            this.items.remove(itemToRemove);
            if (this.items.length > 0 && id === selectedItemId) {
                this.selectItem(this.items[0]);
            }
        }
    };
    State.prototype.update = function (id, newValue, canUpdateSelectedItem) {
        if (canUpdateSelectedItem === void 0) { canUpdateSelectedItem = false; }
        if (canUpdateSelectedItem || this.selectedItemId.get() !== id) {
            this.updateItem(id, newValue);
        }
    };
    State.prototype.updateItem = function (id, newValue) {
        var item = this.getItemById(id);
        item && item.update(newValue);
    };
    State.prototype.getItemById = function (id) {
        return this.items.find(function (x) { return x.id === id; });
    };
    State.prototype.getSelectedItem = function () {
        return this.getItemById(this.selectedItemId.get());
    };
    State.prototype.replaceItems = function (newItems, canUpdateSelectedItem) {
        if (canUpdateSelectedItem === void 0) { canUpdateSelectedItem = false; }
        var selectedItemId = this.selectedItemId.get();
        if (!canUpdateSelectedItem && newItems.length > 0 && newItems.find(function (item) { return item.id === selectedItemId; })) {
            newItems = this.getNewItemsWithoutChangingSelected(newItems, selectedItemId);
        }
        this.items.replace(newItems.sort(function (a, b) { return a.order - b.order; }));
        this.resetSelectedItemId();
    };
    State.prototype.resetSelectedItemId = function () {
        var selectedItemId = this.selectedItemId.get();
        if (this.items.length > 0 && selectedItemId && !this.getItemById(selectedItemId)) {
            this.selectItem(this.items[0]);
        }
    };
    State.prototype.selectInitial = function () {
        var item = this.getInitialItem();
        if (item) {
            this.selectedItemId.set("");
            item && this.selectItem(item);
        }
    };
    State.prototype.getInitialItem = function () {
        return this.getSelectedItem() || this.getItemBySportType(this.defaultItemType);
    };
    State.prototype.getItemBySportType = function (itemType) {
        var item = undefined;
        switch (itemType) {
            case defaultItemForSportMode.favorites:
                item = this.getItemById(itemIDs.favorites);
                break;
            case defaultItemForSportMode.liveStreaming:
                item = this.getItemById(itemIDs.liveStreaming);
                break;
        }
        if (!item) {
            item = this.getFirstSportItem();
        }
        return item;
    };
    State.prototype.getFirstSportItem = function () {
        var e_1, _a;
        try {
            for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                var item = _c.value;
                if (item.order >= 0) {
                    return item;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return undefined;
    };
    State.prototype.getNewItemsWithoutChangingSelected = function (newItems, selectedItemId) {
        var selectedItem = this.getSelectedItem();
        if (selectedItem) {
            newItems = newItems.filter(function (x) { return selectedItemId !== x.id; });
            this.addToList(selectedItem, newItems);
        }
        return newItems;
    };
    State.prototype.selectItem = function (item) {
        if (this.selectedItemId.get() === item.id) {
            return;
        }
        this.messageSender.SendMessage(item);
        this.selectedItemId.set(item.id);
    };
    State.prototype.selectItemById = function (itemId) {
        if (this.isActive) {
            var item = this.getItemById(itemId);
            item && this.selectItem(item);
        }
        else {
            this.selectedItemId.set(itemId);
        }
    };
    State.prototype.clear = function () {
        this.items.replace([]);
    };
    State.prototype.subscribeToToggleEventView = function (BlockUniqueID, channel) {
        this.internalMessageBus.on(BlockUniqueID + "." + channel, this.toggleEventView, this);
    };
    State.prototype.unsubscribeToToggleEventView = function (BlockUniqueID, channel) {
        this.internalMessageBus.off(BlockUniqueID + "." + channel, this.toggleEventView, this);
    };
    State.prototype.toggleEventView = function (topic) {
        topic.data && topic.data[0] && (this.isEventView = topic.data[0].changedToSide);
    };
    __decorate([
        observable,
        __metadata("design:type", Boolean)
    ], State.prototype, "isEventView", void 0);
    __decorate([
        computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], State.prototype, "SelectedItemId", null);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], State.prototype, "toggleEventView", null);
    return State;
}());
export { State };
//# sourceMappingURL=State.js.map